<div class="recommended-wrapper" *ngIf="articles.length > 0">
    <h4 class="recommended-title">📌 À lire aussi sur <span class="afrotech">AfroTech Hub</span></h4>
  
    <div #recommendedSection class="recommended-grid">
      <div class="recommended-card" *ngFor="let article of articles; let i = index">
        <div class="card-image-wrapper">
          <img
            class="card-image"
            [src]="getImageUrl(article)"
            alt="Image de l’article {{ article.attributes.title }}"
          />
        </div>
  
        <div class="card-content">
          <h5 class="article-title">{{ article.attributes.title }}</h5>
  
          <div class="article-meta">
            {{ getAuthor(article) }}<br />
            {{ article.attributes.publishedAt | date: 'd MMM y' }}
          </div>
  
          <div class="card-footer">
            <a class="btn-read" [routerLink]="['/news', article.attributes.slug]" (click)="trackRecommendedArticleClick(article, i)">Lire l’article</a>
            <span 
              class="category-badge"
              [ngStyle]="{
                'background-color': getCategory(article).bgColor,
                'color': getCategory(article).textColor
              }"
            >
              {{ getCategory(article).name }}
            </span>
          </div>          
        </div>
      </div>
    </div>
</div>
  